<template>
    <div class="add-product-shipping">
        <v-layout row justify-center>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" depressed flat class="caption font-weight-regular" style="color: #757575; text-transform: none !important;"
                    :ripple="false">
                    <template v-if="shipping_range.length">PHP {{ formatNumber(Math.min(...shipping_range)) }} - PHP {{ formatNumber(Math.max(...shipping_range)) }}</template>
                    <template v-else>Set shipping settings</template>
                    <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-card style="background-color: #F5F5F5">

                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title class="subheading">Product Shipping Settings</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark flat @click="save">Save</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>

                    <v-alert :value="true" color="grey lighten-4" style="color: black;" icon="all_inbox">
                        Shipping Settings here will be applicable to this product only.
                    </v-alert>

                    <v-content class="package-content pt-0">
                        <v-form style="background-color: #fff;">
                            <!--<v-layout row>-->
                                <!--<v-subheader>-->
                                    <!--<v-icon color="light-green accent-4">radio_button_checked</v-icon> <span class="ml-2">Enabled</span>-->
                                <!--</v-subheader>-->
                            <!--</v-layout>-->
                            <div >
                                <v-divider></v-divider>



                                    <v-list-tile v-for="(courier, index) in couriers" :key="index">
                                        <v-list-tile-avatar>
                                            <v-switch color="info" v-model="couriers[index].selected"></v-switch>
                                            <!--<v-icon color="gray"><v-switch v-model="couriers[index].selected"></v-switch></v-icon>-->
                                        </v-list-tile-avatar>

                                        <v-list-tile-content>
                                            <v-list-tile-title>{{courier.name}}</v-list-tile-title>
                                        </v-list-tile-content>

                                        <v-list-tile-action >
                                            <!--<v-text-field v-if="couriers[index].auto_compute_fee != '1'" label="Subject" placeholder="Set Shipping Fee" suffix hide-details single-line full-width type="number" v-model="couriers[index].fee"></v-text-field>-->
                                            <v-layout  v-if="couriers[index].auto_compute_fee == '1'" row align-center>
                                                <p style="margin-bottom: 0px; text-align: right !important; font-size: 13px; color: #757575; font-weight: 500;">auto compute</p>
                                            </v-layout>

                                        </v-list-tile-action>
                                    </v-list-tile>

                                <v-divider></v-divider>
                            </div>

                        </v-form>
                    </v-content>

                   <!-- <v-content class="package-content pt-3">
                        <v-form style="background-color: #fff;">
                            <v-layout row>
                                <v-subheader>
                                    <v-icon>radio_button_checked</v-icon> <span class="ml-2">Disabled</span>
                                </v-subheader>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row>
                                <v-flex xs6 order-lg2>
                                    <v-card-text>2GO Express</v-card-text>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field label="Subject" placeholder="Set Shipping Fee" suffix hide-details
                                        single-line full-width></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row>
                                <v-flex xs6 order-lg2>
                                    <v-card-text>2GO Express</v-card-text>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field label="Subject" placeholder="Set Shipping Fee" suffix hide-details
                                        single-line full-width></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row>
                                <v-flex xs6 order-lg2>
                                    <v-card-text>JRS Express</v-card-text>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field label="Subject" placeholder="Set Shipping Fee" suffix hide-details
                                        single-line full-width></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row>
                                <v-flex xs6 order-lg2>
                                    <v-card-text>Other Logistic Partner</v-card-text>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field label="Subject" placeholder="Set Shipping Fee" suffix hide-details
                                        single-line full-width></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                        </v-form>
                    </v-content>
                    -->

                </v-card>
            </v-dialog>
        </v-layout>
        <validation-error-modal @hide="validationErrorModal = false" :dialog="validationErrorModal" :error-messages="validationErrorMessages" :title="errorTittle"></validation-error-modal>
    </div>

</template>
<script>
    import ValidationErrorModal from "../../components/ValidationErrorModal";
    export default {
        components: {ValidationErrorModal},
        props :{
            eventName : {
                type : String,
                default : 'setProductShipping'
            },
            couriersProps: {
                type: Array,
                default: () => []
            },
            loadData : {
                type : Boolean,
                default : true,
            },
        },
        name: 'AddProductShipping',
        data() {
            return {
                dialog: false,
                couriers: [],
                validationErrorModal : false,
                validationErrorMessages : [],
                errorTittle : '',
                shipping_range: [],
            }
        },
        watch : {
            couriers: {
                handler: function (after, before) {
                    this.shipping_range = [];
                    after.forEach((value, index) => {
                        if (value.selected && value.fee) {
                            this.shipping_range.push(value.fee);
                        }
                    });
                },
                deep: true,
            },
        },
        methods :{
            getCourier(){
            if (this.loadData){
                    axios.get('/api/courier?showAll=1')

                        .then((response) => {
                            this.couriers = [];
                            response.data.data.forEach((data)=>{
                                this.couriers.push({id : data.id, name : data.name, auto_compute_fee: data.auto_compute_fee, selected : false, fee : data.auto_compute_fee == '1' ? '1' : '1'});
                            });
                        })
                        .catch(err=>{
                            this.toaster('something went wrong.', 201);
                        });
                }

            },
            save(){

                let data = {};
                let couriers = [];
                this.validationErrorMessages = [];
                // let check = false;
                this.couriers.forEach((data, index)=>{
                    if (data.selected){
                        couriers.push({id : data.id, name: data.name, fee : 0});
                        // if (data.fee == ''){
                        //     check = true;
                        //     this.validationErrorMessages.push(`${data.name} fee`);
                        // }
                        // if (data.fee < 0){
                        //     check = true;
                        //     this.validationErrorMessages.push(`${data.name} invalid amount of fee`);
                        // }
                    }

                });
                // if (check) {
                //     this.validationErrorModal = true;
                //     this.errorTittle = 'Please input a valid value';
                // }
                // else
                if(couriers.length == 0){
                    this.validationErrorMessages.push(`Select at least one courier`);
                    this.validationErrorModal = true;
                    this.errorTittle = 'Cannot Save Courier';
            }
                else{
                    data.couriers = couriers;
                    EventBus.$emit(this.eventName, data);
                    this.dialog = false;
                }

            },
            formatNumber(number)
            {
                number = parseFloat(number).toFixed(2) + '';
                let x = number.split('.');
                let x1 = x[0];
                let x2 = x.length > 1 ? '.' + x[1] : '';
                let rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + ',' + '$2');
                }
                return x1 + x2;
            },
            validate(){

            }
        },
        mounted(){
            this.getCourier();
            EventBus.$on('setShippingData',(data)=>{
                this.couriers = data;
            });
        }
    }

</script>

<style lang="scss">
    .add-product-dialog {
        .content {

            .theme--light.v-input:not(.v-input--is-disabled) input,
            .theme--light.v-input:not(.v-input--is-disabled) textarea {
                text-align: right !important;
            }
        }
    }

</style>
